import { Routes } from "@angular/router";
import { AuthGuard } from "@auth0/auth0-angular";
import { guestGuard } from "./core/guards/guest.guard";
import { kycGuard } from "./core/guards/kyc.guard";

export const routes: Routes = [
  {
    path: "terms-of-service",
    loadComponent: () =>
      import("./pages/legal-document/legal-document.component").then(
        (m) => m.LegalDocumentComponent,
      ),
    data: {
      documentType: "terms",
    },
  },
  {
    path: "privacy-policy",
    loadComponent: () =>
      import("./pages/legal-document/legal-document.component").then(
        (m) => m.LegalDocumentComponent,
      ),
    data: {
      documentType: "privacy",
    },
  },
  {
    path: "signup",
    loadComponent: () =>
      import("./pages/sign-up/sign-up.component").then(
        (m) => m.SignUpComponent,
      ),
    canActivate: [guestGuard],
  },
  {
    path: "callback",
    loadComponent: () =>
      import("./pages/callback/callback.component").then(
        (m) => m.CallbackComponent,
      ),
  },
  {
    path: "select-business",
    loadComponent: () =>
      import("./pages/select-business/select-business.component").then(
        (m) => m.SelectBusinessComponent,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: ":businessId",
    loadComponent: () =>
      import("./layouts/main-layout/main-layout.component").then(
        (m) => m.MainLayoutComponent,
      ),
    canActivate: [AuthGuard],
    canActivateChild: [kycGuard],
    children: [
      {
        path: "dashboard",
        loadComponent: () =>
          import("./pages/dashboard/dashboard.component").then(
            (m) => m.DashboardComponent,
          ),
      },
      {
        path: "invoices/confirmation",
        loadComponent: () =>
          import("./pages/invoice-confirmation/invoice-confirmation.component").then(
            (m) => m.InvoiceConfirmationComponent,
          ),
      },
      {
        path: "invoices/new",
        loadComponent: () =>
          import("./pages/new-payment/new-payment.component").then(
            (m) => m.NewPaymentComponent,
          ),
      },
      {
        path: "invoices/new-payment",
        redirectTo: "invoices/new",
      },
      {
        path: "invoices",
        loadComponent: () =>
          import("./pages/invoices-list/invoices-list.component").then(
            (m) => m.InvoicesListComponent,
          ),
      },
      {
        path: "clients",
        loadComponent: () =>
          import("./pages/clients/clients.component").then(
            (m) => m.ClientsComponent,
          ),
      },
      {
        path: "wallet",
        loadComponent: () =>
          import("./pages/wallet/wallet.component").then(
            (m) => m.WalletComponent,
          ),
      },
      {
        path: "settings/accounting",
        loadComponent: () =>
          import("./pages/settings/settings.component").then(
            (m) => m.SettingsComponent,
          ),
      },
      {
        path: "settings",
        loadComponent: () =>
          import("./pages/settings/settings.component").then(
            (m) => m.SettingsComponent,
          ),
      },
      {
        path: "",
        pathMatch: "full",
        redirectTo: "dashboard",
      },
    ],
  },
  {
    path: "",
    pathMatch: "full",
    redirectTo: "select-business",
  },
];
